module.exports = __webpack_public_path__ + "media/images/logo-141b849a57244a04886f702215293cbe.png";